import classNames from 'classnames';

import ImageBlock from './ImageBlock';

import styles from '../../styles/blocks/images-block.module.css';

export interface ImagesBlockProps {
    items: ImageBlock[];
    presentation?: string;
    className?: string | null;
}

function ImagesBlock({ items, presentation = 'grid', className = null }: ImagesBlockProps) {
    return (
        <div className={classNames([styles.container, styles[presentation], className])}>
            <div className={styles.items}>
                {items.map((it, index) => (
                    <div className={styles.item} key={`image-${it.id || index}`}>
                        <ImageBlock {...it} className={styles.block} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ImagesBlock;
